import useXRayPromptBlueprint from "@/queries/playground/useXRayBlueprint";
import { PromptBlueprint, PromptVersion } from "@/types";
import { useState } from "react";

export const useXrayMode = (promptVersion: PromptVersion) => {
  const [isXrayMode, setIsXrayMode] = useState(false);

  const { data } = useXRayPromptBlueprint(promptVersion as PromptBlueprint);

  return {
    isXrayMode,
    XrayBlueprint: data?.prompt_blueprint,
    setIsXrayMode,
    isXrayAvailable: data?.expanded,
  };
};
